module.exports = __webpack_public_path__ + "img/4.b6e4122e.png";